import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/trueproportion.pdf'; 
import { Helmet } from 'react-helmet';
import TrueProportion1 from '../images/trueproportion1.png';
import TrueProportion2 from '../images/trueproportion2.png';
import TrueProportion3 from '../images/trueproportion3.png';
import TrueProportion4 from '../images/trueproportion4.png';

function TrueProportion() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		<var>Acta eruditorum anno MDCLXXXII</var><br />
		pp 41-46<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: November/December 1681<br /><br />
        Translated from the Latin<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (319k)</Link><br /><br />
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On the true proportion of the circle to the circumscribed square, expressed in rational numbers</title>
            <meta name="description" content="An English translation of ON THE TRUE PROPORTION OF THE CIRCLE TO THE CIRUMSCRIBED SQUARE, EXPRESSED IN RATIONAL NUMBERS by Gottfried Wilhelm Leibniz, from November-December 1681" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <td className="pdf-container">
                    <h2 className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON THE TRUE PROPORTION OF THE CIRCLE TO THE CIRUMSCRIBED SQUARE, EXPRESSED IN RATIONAL NUMBERS</h2>
                    {isMobile ? renderLinks() : ''}
                    {isMobile ? <><img src={TrueProportion1} width="100%"/><img src={TrueProportion2} width="100%"/><img src={TrueProportion3} width="100%"/><img src={TrueProportion4} width="100%"/></> : <embed src={pdf} className="responsive-embed"/>}
		              </td>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default TrueProportion;